import type { SVGProps } from 'react'

const HamburgerMenuIcon = ({
  width = 24,
  height = 24,
  fill = '#101010',
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5H22V6.5H2V5ZM2 11.25H22V12.75H2V11.25ZM2 17.5H22V19H2V17.5Z"
        fill={fill}
      />
    </svg>
  )
}

export default HamburgerMenuIcon
